export default "__VITE_PUBLIC_ASSET__ea83b465__"